import { render, staticRenderFns } from "./ConfirmacaoPage.vue?vue&type=template&id=7805dee9&"
import script from "./ConfirmacaoPage.vue?vue&type=script&lang=js&"
export * from "./ConfirmacaoPage.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmacaoPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports